import { Injectable } from "@angular/core";
import { ContainerWithFiltersServiceBase } from "../shared/container-with-filters-service/container-with-filters-service";
import { UiContainerSync } from "../../../core/ui/containers/ui-container-sync";

@Injectable({
    providedIn: "root"
})
export class SettingsContainerService extends UiContainerSync<any> {}
